<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__slaccountlog}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slaccountlog:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slaccountlog:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bizFlow" label="流水号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="reconStatus" label="对账状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="type" label="类型 产生这条记录的操作" header-align="center" align="center"></el-table-column>
        <el-table-column prop="total" label="账户总额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="money" label="操作金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="useMoney" label="可用金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="noUseMoney" label="冻结金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="collection" label="活期累计收益" header-align="center" align="center"></el-table-column>
        <el-table-column prop="toUser" label="交易对方的user_id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="name" label="资金记录类型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column prop="addTime" label="添加时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="addIp" label="添加IP" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="paymentsType" label="收支明细 0：不变  1：收入  2：支出, 3: 充值 ,4: 提现" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="paymentsType" label="收支明细" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.paymentsType == 0">
              不变
            </span>
            <span v-if="scope.row.paymentsType == 1">
              收入
            </span>
            <span v-if="scope.row.paymentsType == 2">
              支出
            </span>
            <span v-if="scope.row.paymentsType == 3">
              充值
            </span>
            <span v-if="scope.row.paymentsType == 3">
              提现
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="tradeStatus" label="交易结果" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.paymentsType == 0">
              交易中
            </span>
            <span v-if="scope.row.paymentsType == 1">
              成功
            </span>
            <span v-if="scope.row.paymentsType == 2">
              失败
            </span>
           
          </template>
        </el-table-column>
        <el-table-column prop="keyId" label="关联外键，更新使用" header-align="center" align="center"></el-table-column>
        <el-table-column prop="showStatus" label="显示状态" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.showStatus == 0 ? '显示' : '不显示' }}</template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:slaccountlog:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:slaccountlog:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './slaccountlog-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/slaccountlog/page',
        getDataListIsPage: true,
        exportURL: '/sys/slaccountlog/export',
        deleteURL: '/sys/slaccountlog',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
